/**
 * Отправка гифки вложением, а не ссылкой. Файл качаем через наш сервер — политика
 * безопасности сайта (connect-src) не пускает браузер на чужой домен, — кладём в наше
 * хранилище и прикрепляем к сообщению: в чате остаётся сама гифка, а не ссылка,
 * и она переживёт и смену адреса, и сам Klipy.
 */
import { authedBlob } from './auth'
import { socialApi } from './socialApi'
import { uploadFile } from './upload'
import { gifFileUrl, type Gif } from './gifsApi'
import type { AttachmentRef } from '@/types/api'

/** Имя файла из названия гифки: латиница, цифры и дефисы. */
function fileName(title: string): string {
  const slug = title
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40)
  return `${slug || 'gif'}.gif`
}

export async function uploadGif(channelId: string, gif: Gif, maxSize: number): Promise<AttachmentRef[]> {
  const blob = await authedBlob(gifFileUrl(gif.full.url))
  if (blob.size > maxSize) throw new Error(`Гифка больше ${Math.round(maxSize / 1024 / 1024)} МБ`)
  const name = fileName(gif.title)
  const id = `gif-${gif.id}`
  const file = new File([blob], name, { type: 'image/gif' })
  const { attachments } = await socialApi.createUploads(channelId, [
    { id, filename: name, file_size: file.size, content_type: 'image/gif' },
  ])
  const slot = attachments[0]
  if (!slot) throw new Error('Хранилище не дало ссылку на загрузку')
  await uploadFile(slot.upload_url, file, () => undefined)
  return [{ id, filename: name, uploaded_filename: slot.upload_filename }]
}
